import script from "./DocumentConstructorPayloadView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentConstructorPayloadView.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentConstructorPayloadView.vue?vue&type=style&index=0&id=3bd0a60e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bd0a60e"]])

export default __exports__